// extracted by mini-css-extract-plugin
export default {"submitBtn":"submitModal_submitBtn__cWipY","contentMsg":"submitModal_contentMsg__szrMk","submitYesNOBtn":"submitModal_submitYesNOBtn__UyflN"};